import React from "react";

function Header() {
  return (
    <header className="header">
      <img src="/logo.png" alt="Logo" className="logo" />
      <h1>Pines de viaje</h1>
    </header>
  );
}

export default Header;
